import { render } from "./CreateEntryButton.vue?vue&type=template&id=7b974242"
import script from "./CreateEntryButton.vue?vue&type=script&lang=js"
export * from "./CreateEntryButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__